module.exports = __webpack_public_path__ + "static/media/close-icon-white-small.5500c7e8.svg";